import { ANALYTICS_TABS, AnalyticsTab, DEFAULT_ANALYTICS_TAB } from "../config/tabs";

/** `?tab=` — sits alongside the report's other URL state so a shared link restores the view. */
export const ANALYTICS_TAB_PARAM_KEY = "tab";

/**
 * Resolves a raw `?tab=` value to a view that actually exists. An unknown or missing
 * value falls back to the default rather than rendering an empty page — the param is
 * user-editable and survives in bookmarks from before a tab was renamed.
 */
export function normalizeAnalyticsTab(raw: string | null | undefined): AnalyticsTab {
	const match = ANALYTICS_TABS.find((tab) => tab.value === raw);

	return match?.value ?? DEFAULT_ANALYTICS_TAB;
}
